import React from "react";

function Skill({ skill }) {
  return <li>{skill}</li>;
}

export default Skill;
